
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2021-01-09-what-im-betting-on",
      function () {
        return require("private-next-pages/blogs/2021-01-09-what-im-betting-on/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2021-01-09-what-im-betting-on"])
      });
    }
  